import { useTranslation } from "react-i18next";import React from 'react';
import { cn } from '@/shared/utils';

export const TemperatureGauge = ({
  value,
  min,
  max,
  unit = '°C',
  size = 'md',
  showRange = true,
  label = 'Current'
}) => {const { t } = useTranslation("ezparcel");
  // Calculate percentage position (0-100)
  const range = max - min;
  const normalizedValue = Math.max(min, Math.min(max, value));
  const percentage = (normalizedValue - min) / range * 100;

  // Determine status color
  const isInRange = value >= min && value <= max;
  const isWarning = !isInRange && value >= min - range * 0.1 && value <= max + range * 0.1;
  const isCritical = !isInRange && !isWarning;

  const statusColor = isCritical ?
  'text-red-600' :
  isWarning ?
  'text-amber-600' :
  'text-emerald-600';

  const bgColor = isCritical ?
  'bg-red-500' :
  isWarning ?
  'bg-amber-500' :
  'bg-emerald-500';

  const sizes = {
    sm: { container: 'w-24 h-24', text: 'text-xl', label: 'text-xs' },
    md: { container: 'w-32 h-32', text: 'text-3xl', label: 'text-sm' },
    lg: { container: 'w-40 h-40', text: 'text-4xl', label: 'text-base' }
  };

  const sizeConfig = sizes[size] || sizes.md;

  return (
    <div className="flex flex-col items-center">
      <div className={cn(
        'relative rounded-full border-8 border-muted flex items-center justify-center',
        sizeConfig.container
      )}>
        {/* Colored arc indicator */}
        <svg
          className="absolute inset-0 -rotate-90"
          viewBox="0 0 100 100">
          
          <circle
            cx="50"
            cy="50"
            r="42"
            fill="none"
            stroke="currentColor"
            strokeWidth="8"
            strokeDasharray={`${percentage * 2.64} 264`}
            className={bgColor}
            strokeLinecap="round" />
          
        </svg>
        
        {/* Center content */}
        <div className="text-center z-10">
          <span className={cn('font-bold font-mono', sizeConfig.text, statusColor)}>
            {value.toFixed(1)}
          </span>
          <span className={cn('font-medium', sizeConfig.label, statusColor)}>
            {unit}
          </span>
        </div>
      </div>
      
      {showRange &&
      <div className="mt-2 text-center">
          <p className={cn('font-medium', sizeConfig.label)}>{label}</p>
          <p className="text-xs text-muted-foreground">{t("range", "Range:")}
          {min}{unit}{t("to", "to")}{max}{unit}
          </p>
        </div>
      }
      
      {!isInRange &&
      <div className={cn(
        'mt-2 px-2 py-1 rounded text-xs font-medium',
        isCritical ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'
      )}>
          {isCritical ? '⚠️ CRITICAL' : '⚡ WARNING'}
        </div>
      }
    </div>);

};